module.exports = __webpack_public_path__ + "img/H-63-ST-450-N.ff2ce27e.png";